import React from "react";
import { Button, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import "./styles.css";

const HowTo = () => {
  return (
    <Container className="p-4 ">
      <Helmet>
        <title>{`CR21 | Help`}</title>
        <meta
          name="description"
          content={
            "Learn about how you can use the various resources available on the portal"
          }
        />
      </Helmet>
      <br />
      <h4>How to search for resources</h4>
      <p>
        If you are looking for state-wise information, simply go to the Location
        Resources tab and select the state you want the resources for. You can
        directly scroll through all the resources you find there, or you can
        further filter the search by selecting the tags (like oxygen, ambulances
        etc), or typing the name of the city in the Search bar. You can also
        find important links to other websites with pan-India resources on the
        Important Links tab, while you can find various home-remedies in the
        Home Therapy tab, which again can be further filtered.
      </p>
      <h4>How to contribute resources</h4>
      <p>
        If you have any links to covid resources of any city or state, simply go
        to the Location Resources tab, and select the state to which the
        resource pertains to. Now, click on the{" "}
        <span className="fabx-icon">+</span> sign on the bottom right corner of
        the window, which shall open up a dialog box where you can enter details
        about the covid resource, including its link. Entering your email ID is
        optional, but recommended. Submit the resource when all the information
        is provided. Our site moderators shall verify the resource and its link
        before making it public on the portal.
      </p>
      <h4>How to suggest corrections to resources</h4>
      <p>
        If you come across any resource having inaccurate information or with
        links that don’t work anymore, you can select the{" "}
        <Button size="sm" variant="outline-primary" disabled>
          Edit
        </Button>{" "}
        option next to the resource which opens up a dialog box for you to
        suggest the changes you recommend. Please fill the correct information
        there, and also a comment mentioning the changes you have made. After
        submitting, the changes you recommend shall be verified by the portal’s
        moderators, and shall be made public on verification.
      </p>
    </Container>
  );
};

export default HowTo;
